import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import Util from '../../../util';
import { Toast } from 'antd-mobile/lib';
import {bankCode} from '../../../BankCode.js';
import {getCardList, hqtCardList} from '../../../action/myAssets/myCardAction';
import { getUserInfoList, getTbuxy, getTbuxyKh } from '../../../action/loginAction'
import { verifiedUserInfo, findCamcHqtExist, hqtExist, modifyUserAccount,getCardListHqt} from '../../../action/myAssets/userInfoAction'
import ModalList from '../../Modal/ModalList';
import { getTempInfo } from '../../../common.js';
import {getPayAll,getOpenHqt,goPubQuestionnaires, judgeQuestionnaires} from '../../../getPay';
import store from '../../../ReduxStore';
import '../../css/Investment.css';

class CurrentDemand extends Component{
  constructor(props){
    super(props);
    this.state={
      cardListType: 0,
      bankCardArray: [],
      huoqitongArray: [],
      showComponent: false,
      unUseBank: false,
      alertFlag:false,
      Bools: false,
      tanCar: false,
      dataVal: ""
    }
  }
  componentWillMount(){
    this.props.dispatch(hqtCardList([]))
  }
  async componentDidMount(){
    let data = store.getState().verifiedUserInfo.content;
    this.setState({dataVal:data})
    let i = localStorage.getItem("loginState");

    console.log(i,"iiiiii")
    if(i && JSON.parse(i) == "2"){
      this.toGetUserInfoList();
      this.toGetCardList();
  
      let verifiedUserInfo = this.props.verifiedUserInfo; /*个人信息*/
      console.log("个人信息",verifiedUserInfo)
      try{
        this.userInfoCallBack(verifiedUserInfo.content)
      }catch(err){
        console.log(err,'err')
      }
    }
  }
  userInfoCallBack(data){
      let inParamsData = {
        certNo:data.certNo,
        certType:data.certType,
        name:data.name
      }
      this.props.dispatch(findCamcHqtExist(inParamsData))
  }
  toGetUserInfoList(){
    this.props.dispatch(getUserInfoList())
  }

  async toGetCardList(){
    Toast.loading();
    let params = {
      token: await getTempInfo('shortToken'),
    }
    this.props.dispatch(getCardList(params, (content)=>this.getCardListSuccess(content), (msg)=>this.getCardListError(msg)))
  }

  getCardListSuccess(content){
    Toast.hide();
    this.setState({showComponent: true});
    //排序函数
    let newData = content.HqtCard
    let allAbleVolume = 0;
    if(newData) {
      for(let i = 0; i < newData.length; i++) {
        allAbleVolume += newData[i].availableVolume;
      }
    }
    // this.setState({
    //   huoqitongArray: newData? newData : [],
    //   allAbleVolume
    // })
    this.setState({
      bankCardArray: content.bankCard? content.bankCard : [],
      allAbleVolume
    })
  }

  getCardListError(msg){
    Toast.hide();
    Toast.info(msg, 2);
  }

  navigatorToHuoqitongDetail(index){
    hashHistory.push({
      pathname: "/HuoqitongDetail",
      state: {
        bankName: this.state.huoqitongArray[index].bankName,
        availableVolume: this.state.huoqitongArray[index].availableVolume,
        bankAccountShowNo: this.state.huoqitongArray[index].bankAccountShowNo,
        trustChannelDisplayName: this.state.huoqitongArray[index].trustChannelDisplayName,
      }
    })
  }

  goDetail = (data) => {
    if(data.trustChannelDisplayName == "招商银行在线支付" && !data.enableCMBTrustChannel) {
      this.setState({
        unUseBank: true
      });
    }else {
      hashHistory.push({
        pathname: "/HuoqitongDetail",
        state: {
          bankCode: data.bankCode,
          bankName: data.bankName,
          availableVolume: data.availableVolume,
          bankAccountShowNo: data.bankAccountShowNo,
          trustChannelDisplayName: data.trustChannelDisplayName,
          enableCMBTrustChannel:data.enableCMBTrustChannel,
          bankAccountShowNo2:data.bankAccountShowNo2 ? data.bankAccountShowNo2 : null,
          showOneKey:data.showOneKey,
          // callback:()=> {  this.toGetCardList() }
        }
      })
    }
  }
  closeMoadlLft = () => {
    this.setState({
      tanCar: false
    })
  }
  closeMoadls = ()=>{
    if(this.state.Bools){
      // if(this.state.dataVal.tradeAccountNo){
      //   this.setState({
      //     tanCar:false
      //   })
      // }else{
        this.props.dispatch(getTbuxyKh({},()=>{
          this.setState({
            tanCar:false
          })
          getOpenHqt(window.history.length,hashHistory,()=> { this.toGetCardList();  this.toGetUserInfoList(); })
        }))
      // }
    }else{
      Toast.info("请先阅读并确认用户同步信息授权书",2);
      return
    }
	}
  closeMoadl = () => {
    this.setState({
      unUseBank: false
    });
  }
  goBack = () => {
    hashHistory.goBack();
  }
  RechargeHqt(){
      let { dispatch,fundCode,hqtCardList } = this.props;
      let data={
        fundCode:'003003',
        businessType:'T022',
        productType:'G',
        bankAccountShowNo:hqtCardList[0].bankAccountShowNo,
      }
      getPayAll( window.history.length, data, hashHistory, 'RechargeHqt')
  }
  openHqt = async ()=>{
      const { findHqtExist, verifiedUserInfo,dispatch } = this.props;
      console.log('findHqtExist',findHqtExist)
      let i = localStorage.getItem("loginState");
      if(i && JSON.parse(i) == "2"){
        console.log("已经开户")
        let isRealHqt = findHqtExist ? findHqtExist.tradeAccountNo : false;
        console.log(isRealHqt,"isRealHqtisRealHqtisRealHqt")
        if(isRealHqt){
            if(findHqtExist.status == '2'){ /*直销已销户状态按照直销未开户来处理*/
              this.setState({tanCar:true})
              // getOpenHqt(window.history.length,hashHistory,()=> { this.toGetCardList();  this.toGetUserInfoList(); })
              return
            }else if(findHqtExist.status != '0'){
              Toast.info( "用户信息异常", Util.ToastTime )
              return
            }else if(findHqtExist.name != verifiedUserInfo.content.name){
              Toast.info( "华夏基金和华夏财富信息不一致", Util.ToastTime )
              return 
            }
            let didQuestionnairs = false;
            try{
              didQuestionnairs = await judgeQuestionnaires("S");
            }catch(err){
              Toast.hide();
              Toast.info(err.message, 2);
              return;
            }
            //判断：如果是私募产品并且公募问卷没有答完
            //如果是公募并且问卷没答完
            if(!didQuestionnairs){
              goPubQuestionnaires(hashHistory, window.history.length, ()=>{ this.openHqt() });
              return;
            }

            hashHistory.push({
              pathname: '/HqtAddCard',
              state:{
                router:window.history.length,
                callback:()=> { this.toGetCardList() }
              }
            })
        }else{
            this.setState({tanCar:true})
            console.log("getOpenHqtgetOpenHqtgetOpenHqt")
            // getOpenHqt(window.history.length,hashHistory,()=> { this.toGetCardList();  this.toGetUserInfoList(); })
        }
      }else{
        this.setState({
          alertFlag:true
        })
      }
  }
  goRealName = () => {
    this.setState({
      alertFlag:false
    })
    this.props.dispatch(hqtExist(false));
    getOpenHqt(window.history.length,hashHistory,()=> {  this.toGetCardList() })
  }
  navigatorToAddCard(){
    hashHistory.push({
      pathname: "/HqtAddCard",
      state:{
        router:window.history.length,hashHistory,
        callback:()=> {  this.toGetCardList() }
      }
    })
  }
  render(){
    let { dispatch, findHqtExist,hqtCardList} = this.props;
    let { allAbleVolume } = this.state
    console.log(hqtCardList,"hqtCardListhqtCardListhqtCardListhqtCardList",findHqtExist)
    let bankCardArray = [];
    let huoqitongArray = [];

    if(this.state.huoqitongArray.length==0){
      huoqitongArray.push(
        <div key={-1} style={{display:"-webkit-flex",Webkitflex:1,WebkitAlignItems:'center',paddingTop:'50%',WebkitJustifyContent:'center'}}>
          <span style = {{fontSize: 15, }}>没有可使用的活期通份额</span>
        </div>
      )
    }else{
      for(let i = 0; i < this.state.huoqitongArray.length; i++){
        huoqitongArray.push(
          <div key={-i} style={this.state.huoqitongArray[i].trustChannelDisplayName == "招商银行在线支付" && !this.state.huoqitongArray[i].enableCMBTrustChannel ? styles.unHqtCardView : Object.assign(styles.HqtCardView, {width: window.winWidth})} onClick={() => {this.goDetail(this.state.huoqitongArray[i])}}
          >
            <div style={{display: "-webkit-flex"}}>
              <div style={styles.HqtCardImgView}>
                <img style={{height:24.5,width:24.5}} src={bankCode.ty[this.state.huoqitongArray[i].bankCode]}/>
              </div>
              <div style={{display:"-webkit-flex",Webkitflex:1, WebkitFlexDirection: "column", WebkitAlignItems: "flex-start"}}>
                <div style={{marginBottom:5}}>
                  <span style={{color: 'rgb(0,0,0)', fontSize: 15, marginTop: 23.5}}>{this.state.huoqitongArray[i].bankName+'(*'+this.state.huoqitongArray[i].bankAccountShowNo.slice(-4)+')'}</span>
                </div>
                <div>
                  {
                    this.state.huoqitongArray[i].trustChannelDisplayName == "招商银行在线支付" && !this.state.huoqitongArray[i].enableCMBTrustChannel ? 
                    <span style={{color:'rgb(104,113,126)',fontSize:12,paddingTop:11}}>不可用</span>
                    :
                    <span style={{color:'rgb(104,113,126)',fontSize:12,paddingTop:11}}>可用余额: {Util.parsePrice(this.state.huoqitongArray[i].availableVolume)}元</span>
                  }
                </div>
              </div>
            </div>
            <div style={styles.centerItems}>
              <img style={styles.rightArrow} src={require('../../../img/rightArrow.png')} />
            </div>
          </div>
        )
      }
    }

    return(
     
      <div style={{backgroundColor: "#f2f5f7"}} className="mainBox">

        <div className="boxHeader">
          <div>
            <img onClick={this.goBack} src={require("../../../img/leftArrow_header.png")} />
          </div>
          <div>
            <span>活期通</span>
          </div>
          <div>
            
          </div>
        </div>


        {hqtCardList.length > 0?
        <div className="content" style={{paddingBottom:40 }}>
            <div style={{height:124,backgroundColor:"#FFF",textAlign:'center',marginBottom:10,paddingTop:20}}>
              <div style={{fontSize:15}}>活期通可用余额(元)</div>
              <div style={{fontSize:30,marginTop:20}}>{Util.parsePrice(allAbleVolume)}</div>
            </div>
          {
            hqtCardList.map((item,index)=>
              <div key={-index} style={ Object.assign(styles.HqtCardView, {width: window.winWidth})} onClick={() => {this.goDetail(item)}}
              >
                <div style={{display: "-webkit-flex"}}>
                  <div style={styles.HqtCardImgView}>
                    <img style={{height:24.5,width:24.5}} src={bankCode.ty[item.bankCode]}/>
                  </div>
                  <div style={{display:"-webkit-flex",Webkitflex:1, WebkitFlexDirection: "column", WebkitAlignItems: "flex-start"}}>
                    <div style={{marginBottom:5}}>
                      <span style={{color: 'rgb(0,0,0)', fontSize: 15, marginTop: 23.5}}>{item.bankName+'(*'+item.bankAccountShowNo.slice(-4)+')'}</span>
                      {
                        item.enableCMBTrustChannel  === false || item.enableCMBTrustChannel === "0" ? 
                        <span style={{color:'rgb(104,113,126)',fontSize:12,padding:2,marginLeft:5,backgroundColor:"rgba(0,0,0,0.1)",justifyContent:"center"}}>不可用</span> : null
                      }
                    </div>
                    <div>
                      {
                        <span style={{color:'rgb(104,113,126)',fontSize:12,paddingTop:11}}>可用余额: {Util.parsePrice(item.availableVolume)}元</span>
                      }
                    </div>
                  </div>
                </div>
                <div style={styles.centerItems}>
                  <img style={styles.rightArrow} src={require('../../../img/rightArrow.png')} />
                </div>
              </div>
            )
          }
          <div style={{ paddingLeft:13, paddingRight:13,marginTop:"0.3rem",marginBottom:"0.4rem" }}>
            <div style = {{ color: '#FE492E', fontSize: 15,backgroundColor: '#FFF', 
                height: 40,borderRadius: 20,borderColor:"#e1e3e6",borderWidth:1 ,textAlign:'center', lineHeight:"40px"
                }}
                onClick={ ()=> { this.navigatorToAddCard() } }
            >
              +添加银行卡 
            </div>
          </div>

          <div style={{ paddingLeft:8, paddingRight:8,paddingBottom:20}}>
            <div style={{fontSize:13,marginBottom:5,color:"#5b6370"}}>温馨提示:</div>
            <div style={styles.txtStyle} > 1、活期通是有华夏基金提供的理财产品，您可使用活期通份额申购华夏财富代销的产品,认申购费率最低可享受1折优惠;</div>
            <div style={styles.txtStyle} > 2、华夏财富仅可进行活期通充值,如需办理活期通赎回、交易查询等业务,请登录华夏基金管家;</div>
            <div style={styles.txtStyle} > 3、如需变更活期通对应的银行卡,您需要分别登陆华夏基金官网和华夏财富官网进行银行卡变更,您也可以致电客服热线400-817-5666咨询办理。</div>
          </div>
          <div style={{ position:"fixed",bottom:0,width:'100%',height:40 }} >
            <div className="currentDemandBot_btn">
              <div className="bottom_btn1" onClick={ ()=> {   hashHistory.push({ pathname: "/home" }) }} >买基金</div>
              <div className="bottom_btn2" onClick={ ()=> { this.RechargeHqt() } }>存入活期通</div>
            </div>
          </div>

        </div>:
        <div className="content" style={{ background:"#FFF" }}>
          <div>
            <img style={{width:window.winWidth, height:window.winWidth*(650/750) }} src={require("../../../img/hqt_bg.png")} >

            </img>
            <div style={{ paddingLeft:13, paddingRight:12,paddingTop:'0.6rem'}}>
              <div style={styles.openHqtBtn} onClick={ this.openHqt }>开通活期通</div>
            </div>
          </div>
      
          <div style={{ position:'absolute', bottom:15,left:0}}>
            <img style={{width:window.winWidth, height:window.winWidth*(64/750) }} src={require("../../../img/hqt_bg_bot.png")} />
          </div>
        </div>
        }

        <ModalList flag={this.state.unUseBank} btnRight={"确认"} btnRightFun={this.closeMoadl} content={"该渠道份额不可用，需提交相关证明资料。如需办理，请联系您的理财顾问或拨打客服电话400-817-5666。"} title={"银行渠道提示"} />

        <ModalList flag={this.state.alertFlag} 
                   btnLeft={"取消"} btnLeftFun={()=>{ this.setState({ alertFlag:false  }) }} 
                   btnRight={"确认"} btnRightFun={()=>{ this.goRealName() }} 
                   content={"尊敬的客户，请先完成实名认证，方可开通华夏基金活期通。"} title={"开通活期通提示"} 
        />
        <ModalList onFun={(Bools)=>{this.setState({Bools:Bools})}} flag={this.state.tanCar} btnLiftFun={this.closeMoadlLft} btnLift={"取消"} btnRight={"确认"} btnRightFun={this.closeMoadls} content={"为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》"} title={""} />
      </div>
    );
  }
}

class BankCard extends Component{
  constructor(props){
    super(props);
  }

  doSecureForBankCardNo(bankCardNo){
    let end = bankCardNo.substring(bankCardNo.length - 4, bankCardNo.length);
    return '**** **** **** ' + end;
  }

  render(){
    return (
      <div 
      style = {this.props.style} 
      onClick = {()=>hashHistory.push({
        pathname: "/CardDetail",
        state: {
          bankCardNo: this.props.bankCardNo,
          bankCode: this.props.bankCode,
          bankName: this.props.bankName,
          cardListType: this.props.cardListType,
          currentAccountId: this.props.currentAccountId,
          trustChannelId: this.props.trustChannelId,
        }
      })} 
      >
        <div style = {Object.assign({backgroundImage:`url(${this.props.imageRequire})`}, styles.bankCardView, styles.bankCardImage, {width: window.winWidth-26})}>
          <span style = {styles.bankCardNo}>{this.doSecureForBankCardNo(this.props.bankCardNo)}</span>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "-webkit-flex",
    WebkitFlex: 1,
    WebkitAlignItems: 'stretch',
  },
  centerItems: {
    display: "-webkit-flex",
    WebkitFlexDirection: 'row',
    WebkitJustifyContent: 'center',
    WebkitAlignItems: 'center',
  },
  headerView: {
    display: "-webkit-flex",
    height: 44,
    backgroundColor: "rgb(38, 42, 48)",
    WebkitFlexDirection: "row",
    WebkitJustifyContent: "space-between",
    WebkitAlignItems:'center'
  },
  headerLeftView: {
    marginTop: 0,
  },
  headerMiddleView: {
    marginTop: 0,
    height: 44,
  },
  headerRightView: {
    marginTop: 20,
  },
  headerMiddleContent: {
    fontSize: 15,
    color: '#fff',
    backgroundColor: 'transparent',
  },
  headerRightContent: {
    height: 44,
    width: 44,
    backgroundColor: 'transparent',
  },
  headerTouchHighlightBtn: {
    marginLeft: 3.5,
    marginRight: 3.5,
    borderRadius: 13.5,
  },
  inputContainer: {
    display: "-webkit-flex",
    width: 'auto',
    height: 45,
    borderBottomColor: 'rgba(242,245,247,1)',
    borderBottomWidth: 1,
    backgroundColor: '#ffffff',
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center',
  },
  flexViewContainer: {
    display: "-webkit-flex",
    WebkitFlex: 1,
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center',
  },
  centerItems: {
    display: "-webkit-flex",
    WebkitFlexDirection: 'row',
    WebkitJustifyContent: 'center',
    WebkitAlignItems: 'center',
  },
  headerItem: {
    display: "-webkit-flex",
    backgroundColor: '#FE492E',
    height: 27,
    width: 115,
    borderRadius: 13.5,
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center',
    WebkitJustifyContent: 'center',
  },
  headerItemInversed: {
    display: "-webkit-flex",
    backgroundColor: '#32393f',
    height: 27,
    width: 115,
    borderRadius: 13.5,
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center',
    WebkitJustifyContent: 'center',
  },
  rightArrow:{
    marginRight: -2,
    width: 44,
    height: 44,
  },
  bankCardScrollView: {
    overflow:"auto",
    paddingTop: 3
  },
  bankCardHeight: {
    marginBottom: 10,
    marginLeft: 13,
    marginRight: 13,
  },
  bottomTouchHighlightBtn: {
    marginTop: 15,
    marginBottom: 15,
    marginLeft: 13,
    marginRight: 13,
    borderRadius: 20,
  },
  loginView: {
    display: "-webkit-flex",
    backgroundColor: '#FE492E',
    height: 40,
    borderRadius: 20,
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center',
    WebkitJustifyContent: 'center',
  }, 
  bankCardImage: {
    display: "-webkit-flex",
    WebkitAlignSelf: 'stretch',
    WebkitFlex: 1,
  },
  bankCardView: {
    display: "-webkit-flex",
    backgroundColor: 'rgba(0,0,0,0)',
    WebkitFlex: 1,
    WebkitAlignSelf: 'stretch',
    height: 85,
    backgroundSize: "contain",
    position: "relative"
  },
  bankCardNo: {
    display: "-webkit-flex",
    fontSize: 22,
    lineHeight: "22px",
    color: '#ffffff',
    WebkitAlignSelf: 'flex-end',
    right:13,
    bottom: 8,
    position: 'absolute'
  },
  HqtCardView: {
    display: "-webkit-flex",
    width: 'auto',
    height: 86,
    borderBottomColor: 'rgba(242,245,247,1)',
    borderBottomWidth: 1,
    WebkitFlexDirection: "row",
    WebkitAlignItems: 'center',
    backgroundColor:'#fff',
    borderBottomStyle:"solid",
    WebkitJustifyContent: "space-between"
  },  
  unHqtCardView: {
    width: 'auto',
    height: 86,
    borderBottomColor: 'rgba(242,245,247,1)',
    borderBottomWidth: 1,
    WebkitFlexDirection: "row",
    WebkitAlignItems: 'center',
    backgroundColor:'rgba(0,0,0,0.1)',
  },  
  HqtCardImgView: {
    marginLeft: 13,
    marginRight: 5,
    height: 44.5,
    width:24.5
  },
  openHqtBtn:{
    backgroundColor:"#FE492E", height:"0.8rem", alignItems:'center', justifyContent:'center' ,
    borderRadius:20,
    color:"#FFF",lineHeight:"0.8rem", textAlign:'center'
  },
  txtStyle:{
    lineHeight:'16px',fontSize:12,marginTop:10,
    color:"#a1a7b2"
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    verifiedUserInfo: state.verifiedUserInfo,
    findHqtExist:state.findHqtExist,
    payLoading:state.payLoading,
    hqtCardList:state.hqtCardList
  }
}

export default connect(mapStateToProps)(CurrentDemand);






// WEBPACK FOOTER //
// ./src/components/myAssets/myCard/CurrentDemand.js